import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { GenericService } from '../service/generic.service';
import { Store } from '@ngxs/store';
import { ObjectUtils } from '@cv-invision/core';
import { GenericEditableTableComponent } from '../generic-editable-table/generic-editable-table.component';

@Component({
	selector: 'cv-generic-document-types',
	templateUrl: '../../components/tables/editable-table/editable-table.component.html',
	providers: [ConfirmationService, MessageService]
})
export class GenericDocumentTypesComponent extends GenericEditableTableComponent implements OnInit {
	public model: Array<any> = [
		{
			label: 'Integration Id',
			key: 'key'
		},
		{
			label: 'Integration Label',
			key: 'label'
		},
		{
			label: 'Tracking System',
			key: 'trackingSystem',
			type: 'select',
			options: [
				{ label: 'AppScope', value: 'AppScope' },
				{ label: 'Acuity', value: 'Acuity' },
			],
			onChange: ($event: any, row: any) => {
				if ($event.value === 'Acuity') {
					this.model[3].options = this.acuityOptions;
				} else {
					this.model[3].options = this.appScopeOptions;
				}

				if (this.model[3].options[0]) {
					const selectedValue = this.model[3].options[0];

					this.data[row.id] = {
						...row,
						...{
							trackingSystemId: selectedValue.value,
							trackingSystemLabel: selectedValue.label
						}
					};
				}
			}
		},
		{
			label: 'Tracking System Option',
			key: 'trackingSystemId',
			type: 'select',
			options: [],
			onChange: ($event: any, row: any) => {
				let selectedValue = [];

				if (row.trackingSystem === 'Acuity') {
					selectedValue = this.acuityOptions.filter(option => option.value === $event.value);
				} else {
					selectedValue = this.appScopeOptions.filter(option => option.value === $event.value);
				}

				if (selectedValue.length) {
					this.data[row.id] = { ...row, ...{trackingSystemId: selectedValue[0].value, trackingSystemLabel: selectedValue[0].label} };
				}
			},
			getValue: (field: any, row: any) => {
				return row['trackingSystemLabel'];
			}
		},
		{
			label: 'Tracking System Id',
			key: 'trackingSystemId',
			disabled: true
		},
		{
			label: 'Tracking System Label',
			key: 'trackingSystemLabel',
			disabled: true
		},
		{
			label: 'Direction',
			key: 'direction',
			type: 'select',
			options: [
				{ label: 'Both', value: 'Both' },
				{ label: 'Output', value: 'Output' },
				{ label: 'Input', value: 'Input' },
			]
		},
	];

	public appScopeOptions: Array<any>;
	public acuityOptions: Array<any>;

	constructor(
		public confirmationService: ConfirmationService,
		public messageService: MessageService,
		protected service: GenericService,
		private store: Store,)
	{
		super(confirmationService, messageService, service);
	}

	ngOnInit(): void {
		const appScopes = this.store.selectSnapshot((state: any) => ObjectUtils.getStateFromString(state, 'globalConfiguration.appScope.documentTypes'));

		this.appScopeOptions = appScopes.map((appScope: any) => {
			return {
				label: appScope.name,
				value: appScope.id,
			}
		});

		const acuities = this.store.selectSnapshot((state: any) => ObjectUtils.getStateFromString(state, 'globalConfiguration.acuity.documentTypes'));

		this.acuityOptions = acuities.map((acuity: any) => {
			return {
				label: acuity.name,
				value: acuity.id,
			}
		});

		this.service.setConfiguration(this.integrationId, this.entity);
		super.ngOnInit();
	}

	onRowEditInit(row: any) {
		this.service.setConfiguration(this.integrationId, this.entity);

		if (row.trackingSystem === 'Acuity') {
			this.model[3].options = this.acuityOptions;
		} else {
			this.model[3].options = this.appScopeOptions;
		}

		this.clonedData[row.id] = { ...row };
	}
}
